import { render, staticRenderFns } from "./essayDetail.vue?vue&type=template&id=23f78ba4&scoped=true"
import script from "./essayDetail.vue?vue&type=script&lang=js"
export * from "./essayDetail.vue?vue&type=script&lang=js"
import style0 from "./essayDetail.vue?vue&type=style&index=0&id=23f78ba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f78ba4",
  null
  
)

export default component.exports